import { render, staticRenderFns } from "./NodeReport.vue?vue&type=template&id=36bc60cb&scoped=true"
import script from "./NodeReport.vue?vue&type=script&lang=js"
export * from "./NodeReport.vue?vue&type=script&lang=js"
import style0 from "./NodeReport.vue?vue&type=style&index=0&id=36bc60cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc60cb",
  null
  
)

export default component.exports